import styled from 'styled-components';

const PercentBox = styled.div`
  width: 32%;
  padding-left: 10px;
  margin-top: 20px;
  display: flex;
  margin-top: 15px;
  margin-bottom: 10px;
  align-items: center;
  gap: 10px;
  @media (max-width: 520px) {
    width: 60%;
  }
`;

PercentBox.PercentText = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -5px;
  .title-percent {
    color: #868686;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.16px;
  }
  .status-percent {
    color: #868686;
    font-size: 11px;
    letter-spacing: 0.16px;
  }
  .next-percent {
    color: #868686;
    font-size: 11px;
    letter-spacing: 0.16px;
  }
`;

export default PercentBox;
